(function($) { 

  let $headerlogo = $('.site-header-primary-section-left .custom-logo.astra-logo-svg')
  if($headerlogo.length) {  

    const $logo = $headerlogo.eq(1)
    const actimg = $logo.attr('src')
    let logoatra = false 
    let logoatrb = false 

    const resize = () => {

      if(window.innerWidth < 544) {

        if(!logoatra) {

          $logo.attr('src', '/wp-content/uploads/2025/02/Bahco-Academy-Logo-two-lines.svg')
          logoatra = true
        }

        logoatrb = false

      } else {
        
        if(!logoatrb) {

          $logo.attr('src', actimg)
          logoatrb = true
        }

        logoatra = false
      }

      const $content = $('#content')
      const $desktopheader = $('#ast-desktop-header')
      const $mobileheader = $('#ast-mobile-header')
      const $desktopheadervisible = $desktopheader.is(':visible')
      const $mobileheadervisible = $mobileheader.is(':visible')
      let headerheight = 0

      if($desktopheadervisible) { headerheight = $desktopheader.height()  }
      if($mobileheadervisible) { headerheight = $mobileheader.height()  }

      $content.css('top', headerheight + 'px')
    }

    window.addEventListener(
      'resize',
      resize
    )

    resize()
  }  

})(jQuery)